<template>
    <div class="poll-card">
        <div class="question">
            {{ poll.poll_languages[0].pivot.title }}
        </div>
        <div class="options" v-if="expiredPoll">
            <div class="option" style="position: relative; background:white" v-for="pollOption in pollData.poll_options">
                <div
                    :style="{
                    width: `${pollOption.vote_percentage}%`,
                    position: 'absolute',
                    zIndex: 1,
                    height: '100%',
                    left:0,
                    top:0,
                    backgroundColor: 'rgba(128,128,128,0.25)'
                }"></div>
                <div class="analytic" style="position: relative; z-index: 3; width: 100%">
                    <!--                    <div class="bar"></div>-->
                    <div class="percent"> {{ pollOption.vote_percentage }} %</div>
                </div>
                <div class="input" style="position: relative; z-index: 2; background: transparent">
                    <input type="submit" :id="'option-' + pollOption.id" name="option" hidden>
                    <label :for="'option-' + pollOption.id">
                        {{ pollOption.poll_option_languages[0].pivot.title }}
                    </label>
                </div>

            </div>
            <div>
                <p style="float: right; margin-top: 23px; font-weight: 600;font-size: 0.875rem;display: block;color: var(--cdl-secondary);">
                    <span>{{ poll.total_votes }} votes, </span>
                    <span style="color:var(--cdl-primary)">Expired</span>

                </p>
            </div>

        </div>

        <div class="options" v-else>
            <div class="option" style="position: relative; background:white" v-for="pollOption in pollData.poll_options" v-if="!loading">
                <div
                    :style="{
                    width: `${pollOption.vote_percentage}%`,
                    position: 'absolute',
                    zIndex: 1,
                    height: '100%',
                    left:0,
                    top:0
                }"
                    :class="{'selected': pollData.submitted_option && pollData.submitted_option.id === pollOption.id,
                                     'not-selected': pollData.submitted_option && pollData.submitted_option.id !== pollOption.id,
                                      'hidden': loading }"></div>
                <div class="analytic" style="position: relative; z-index: 3; width: 100%">
                    <!--                    <div class="bar"></div>-->
                    <div class="percent" v-if="pollData.submitted_option"> {{ pollOption.vote_percentage }} %</div>
                </div>
                <div class="input" style="position: relative; z-index: 2; background: transparent">
                    <input type="submit" :id="'option-' + pollOption.id" name="option" hidden
                           :disabled="hasVotedLocally || pollData.submitted_option != null"
                           @click="submitPoll(poll.id, pollOption.id)">
                    <label :for="'option-' + pollOption.id"
                           :class="{'disabled-label': hasVotedLocally || pollData.submitted_option != null}">
                        {{ pollOption.poll_option_languages[0].pivot.title }}
                    </label>
                </div>

            </div>
            <div class="loading" v-else>Loading...</div>
            <div>
                <p style="float: right; margin-top: 23px; font-weight: 600;font-size: 0.875rem;display: block;color: var(--cdl-secondary);">
                    <span>{{ pollData.total_votes }} votes, </span>
                    <span>{{ daysAndHoursLeft(poll.end_date) }}</span>

                </p>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: "Poll",
    props: {
        poll: {
            default: null
        },
    },
    data() {
        return {
            loading: false,
            pollData: this.poll,
            hasVotedLocally: false
        }
    },
    methods: {

        daysAndHoursLeft(endDate) {
            const endDateObject = new Date(endDate);
            const currentDate = new Date();

            const timeDifference = endDateObject.getTime() - currentDate.getTime();

            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

            return `${days} days and ${hours} hours left`;
        },

        async submitPoll(pollId, pollOptionId) {
            if (this.hasVotedLocally || this.pollData.submitted_option != null) {
                return;
            }

            this.loading = true;

            try {
                const recaptchaToken = await this.getRecaptchaToken();

                const response = await axios.post("/api/poll", {
                    poll_id: pollId,
                    poll_option_id: pollOptionId,
                    'g-recaptcha-response': recaptchaToken
                });

                this.loading = false;

                const votedOption = response.data.poll_options.find(opt => opt.id === pollOptionId);
                this.pollData = response.data;

                this.saveVoteToLocalStorage(pollId, pollOptionId);
                this.pollData.submitted_option = votedOption
                this.hasVotedLocally = true;

            } catch (error) {
                this.loading = false;
                console.error(error);
            }
        },
        checkLocalStorage() {
            const votedPolls = JSON.parse(localStorage.getItem('votedPolls') || '{}');
            const pollKey = `poll_${this.poll.id}`;

            if (votedPolls[pollKey]) {
                this.hasVotedLocally = true;
                const votedOptionId = votedPolls[pollKey].optionId;
                this.pollData.submitted_option = this.pollData.poll_options.find(
                    opt => opt.id === votedOptionId
                )
            }
        },
        saveVoteToLocalStorage(pollId, pollOptionId) {
            const votedPolls = JSON.parse(localStorage.getItem('votedPolls') || '{}');
            votedPolls[`poll_${pollId}`] = {
                optionId: pollOptionId,
                timestamp: Date.now()
            };
            localStorage.setItem('votedPolls', JSON.stringify(votedPolls));
        },
        async getRecaptchaToken() {
            return new Promise((resolve, reject) => {
                if (typeof grecaptcha === 'undefined') {
                    reject('reCAPTCHA not loaded');
                    return;
                }

                grecaptcha.ready(() => {
                    grecaptcha.execute(window.recaptchaSiteKey, {action: 'poll_vote'})
                        .then(token => resolve(token))
                        .catch(error => reject(error));
                });
            });
        }
    },
    computed: {
        expiredPoll() {
            const endDate = new Date(this.poll.end_date);
            const currentDate = new Date();
            return endDate < currentDate;
        }
    },
    mounted() {
        this.checkLocalStorage()
    }
}
</script>

<style scoped>

.poll-card {
    width: 100%;
    padding: 1rem 1.5rem;
}

.question {
    font-weight: 700;
    margin-bottom: 1rem;
}

.option {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0.4rem 0;
    border: 1px solid #c9c9c9;
    border-radius: 4px;
    position: relative;
    min-height: 48px;
}


.input {
    width: 100%;
    background-color: #fff;
}

label {
    display: block;
    cursor: pointer;
    padding: 0.8rem;
    padding-right: 4rem;
    word-wrap: break-word;
    word-break: break-word;
}

label.disabled-label {
    cursor: not-allowed;
    opacity: 1;
}

.percent {
    position: absolute;
    right: 7px;
    top: 50%;
    font-weight: 700;
    white-space: nowrap;
    padding: 0.5rem;
}


.selected {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #e9e9e9;
    height: 100%;
    z-index: 0
}

.not-selected {
    background-color: #e9e9e9;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    z-index: 0

}

.loading {
    margin-top: 5px;
    width: 100%;
    margin-left: 2rem;
    height: 40px;
    color: var(--cdl-primary);
    font-size: 1rem;
    font-weight: 700;
    appearance: none;
    border: 1px var(--cdl-light) solid;
}

@media (max-width: 640px) {
    label {
        padding-right: 3.5rem;
        font-size: 0.9rem;
    }

    .percent {
        font-size: 0.85rem;
        right: 5px;
    }
}
</style>
